export default __webpack_public_path__ + "static/media/actividad-40.10c18934.mp3";